import { type FC } from 'react'

import { Box, Card, Skeleton, Stack, StackColumn } from '@dhl-ui/components'

export const NewServicepointInAreaContentSkeleton: FC = () => (
  <Stack spacing={3}>
    <Card hasPaddingBottom>
      <Card.Content>
        <StackColumn gap={3}>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Stack alignItems="center" spacing={2}>
              <Skeleton variant="rounded" width={160} height={160} />
              <Skeleton variant="text" width={250} height={20} />
            </Stack>
          </Box>

          <Skeleton variant="rounded" width="100%" height={160} />
        </StackColumn>
      </Card.Content>
    </Card>
  </Stack>
)
